import { postRequest } from '../../../shared/utils';

export async function getAllHtz(htz: string, screenGridId: number) {
  const body = {
    columns: ['htz'],
    screenGridId,
    schema: 'npi',
    table: 'qry_search',
    key: 'htz',
    filterModel: {
      items: [
        {
          field: 'htz',
          value: htz ? `${htz}` : '',
          operator: 'contains', // 'contains' === '_ilike'
        },
      ],
    },
    limitNumber: 20,
    orderCol: 'htz',
    order: 'asc',
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    console.error(errors);
    return null;
  }

  return data;
}

export async function getHtzValues(htz: string, queryColumns: string[], screenGridId: number) {
  const body = {
    columns: queryColumns,
    screenGridId,
    schema: 'npi',
    table: 'qry_search',
    key: 'htz',
    value: htz,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    console.error(errors);
    return null;
  }

  return data;
}
